export default function getPageSlug(pages, item, preSlug) {

  if (!item) return;

  if (typeof item === 'string') return preSlug ? preSlug+item : item;

  const {
    pageId,
    href
  } = item;

  if (href) return href;

  let pageSlug;
  for (let i = 0; i < pages.length; i++) {
    if (pages[i].pageId === pageId) pageSlug = pages[i].slug === '/' ? '/' : `/${pages[i].slug}`;
  }

  if (pageSlug === '/speaker') return;
  return pageSlug && preSlug ? preSlug+pageSlug : pageSlug ? pageSlug : '/';
}